import React from 'react';
import s from './MonthStatistic.module.scss';


const MonthStatistic = (props) => {
  return (
    <div className={s.home}>
        Month
    </div>
  )
}

export default MonthStatistic;